exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".guide[data-v-0a334a61]{max-width:90%;margin:0 auto 5%}.form-header[data-v-0a334a61]{margin-top:3%;margin-bottom:2%}.guide-photo-img[data-v-0a334a61]{max-width:100%}.float-button[data-v-0a334a61]{position:fixed;bottom:20px;right:20px}.addAccount[data-v-0a334a61]{cursor:pointer}.section-divider[data-v-0a334a61]{border:1px dashed grey}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-0a334a61","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/users/Guide.vue
// module id = 878
// module chunks = 0